/* eslint-disable */
import videojs from 'video.js';
import './SkipBackward.css';
import backwardImg from '../../assets/backward.svg';

const Button = videojs.getComponent('Button');

class SkipBackward extends Button {
  constructor(player, options) {
    super(player, options);
  }

  handleClick() {
    const currentTime = this.player().currentTime();
    this.player().currentTime(currentTime - 5);
  }

  createEl() {
    return videojs.dom.createEl('button', {
      className: 'vjs-custom-skip-back-5',
      innerHTML: `<img src="${backwardImg}" />`,
      
    });
  }
}

// Register new SkipForward component class
videojs.registerComponent('SkipBackward', SkipBackward);
